import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addAttandence = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Attendance', body);
  return data;
});
export const updateAttandence = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Attendance/${id}`,
    body
  );
  return data;
});

export const getAttandence = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Attendance?fields=["name","employee_name","attendance_date","status","docstatus"]'
  );
  return data;
});
export const deleteAttandence = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Attendance/${record}`
  );
  return data;
});
export const getAttandenceDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Attendance/${id}`);
  return data;
});
